export default function updateFromData(updateObj, value) {

    if(typeof updateObj !== 'object' && value !== undefined) {
        updateObj = {[updateObj]: value};
    }

    return Object.assign({}, updateObj);
}